var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm.001 10.403a.799.799 0 1 0 0 1.598.799.799 0 0 0 0-1.598ZM10 6a.8.8 0 0 0-.795.707L9.2 6.8l.001 4.001.006.093a.8.8 0 0 0 1.59 0l.004-.094-.001-4-.005-.094A.8.8 0 0 0 10 6Z",
    fill: "#E53935"
  })));
};
export default SvgExclamation;